import React from "react";

const Markup = ({ renderField, renderSelect, Button, ...props }) => {
    const { deviceNumber, type, organizationId, isRoot, isTechSupport, isIntegrationManager } = props;
    return (
        <>
            {renderField(deviceNumber)}
            {renderSelect(type)}
            {!!(isRoot || isTechSupport || isIntegrationManager) && renderSelect(organizationId)}
            {!!Button && <Button />}
        </>
    );
};

export default Markup;
